import { render, staticRenderFns } from "./EmailForma.vue?vue&type=template&id=2aa22e0c&scoped=true&"
import script from "./EmailForma.vue?vue&type=script&lang=js&"
export * from "./EmailForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa22e0c",
  null
  
)

export default component.exports